import { makeStyles } from "@material-ui/core/styles";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";
import { useCallback, useState } from "react";
import { SIGWX_LONDON, SIGWX_WASHINGTON } from "../layers/Sigwx";
import { weatherTimeWithID, WX_ID_SIGWX } from "../../../store/WeatherContentsState";
import { useRecoilValue } from "recoil";
import iceModImg from "../../../images/contents/map/sigwx/ice_mod.png";
import iceSevImg from "../../../images/contents/map/sigwx/ice_sev.png";
import tropicStormSevNImg from "../../../images/contents/map/sigwx/tropic_storm_sev_n.png";
import turbModImg from "../../../images/contents/map/sigwx/turb_mod.png";
import turbSevImg from "../../../images/contents/map/sigwx/turb_sev.png";
import cbImg from "../../../images/contents/map/sigwx/legend/cb.png";
import jetImg from "../../../images/contents/map/sigwx/legend/jet.png";
import tropoHeightImg from "../../../images/contents/map/sigwx/legend/tropo_height.png";
import tropoHighImg from "../../../images/contents/map/sigwx/legend/tropo_high.png";
import tropoLowImg from "../../../images/contents/map/sigwx/legend/tropo_low.png";

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'flex',
    flexDirection:'row',
    flexWrap:'wrap',
    justifyContent: 'flex-start'
  },
  dataSourceLabel: {
    fontSize:"12px"
  },
  item: {
    position: 'relative',
    lineHeight: '30px',
    height: '30px',
    paddingLeft: '10px'
  },
  iconWrap: {
    width: "40px",
    display: "inline-block"
  },
  icon: {
    verticalAlign: "middle"
  },
  iconMini: {
    height: "22px"
  },
  iconJet: {
    height: "16px"
  },
  iconCB: {
    width:'42px',
    height: "7px"
  },
  iconTropoHeight: {
    height: '13px'
  },
  label: {
    display: "inline-block",
    textAlign: 'left',
    paddingLeft: '5px',
    width:100,
    whiteSpace: "nowrap"
  },
  catLine:{
    position: 'relative',
    display:  'inline-block',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '30px',
    height: '5px',
    '&:before': {
      position: 'absolute',
      display: 'block',
      content: "''",
      left: 0,
      width: '14px'
    },
    '&:after': {
      position: 'absolute',
      display: 'block',
      content: "''",
      right: 0,
      width: '14px'
    }
  },
  catMod: {
    '&:before': {
      borderTop: '2px solid #F28CBB'
    },
    '&:after': {
      borderTop: '2px solid #F28CBB'
    }
  },
  catModSev: {
    '&:before': {
      borderTop: '2px solid #FF5E19'
    },
    '&:after': {
      borderTop: '2px solid #FF5E19'
    }
  },
  catSev: {
    '&:before': {
      borderTop: '2px solid #CC000A'
    },
    '&:after': {
      borderTop: '2px solid #CC000A'
    }
  },
  turb: {
    display: 'inline-block',
    '&:before': {
      display: 'inline-block',
      content: "''",
      background: `url(${turbModImg}) no-repeat left top`,
      width: '20px',
      height: '13px',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    '&:after': {
      display: 'inline-block',
      content: "''",
      background: `url(${turbSevImg}) no-repeat left top`,
      width: '20px',
      height: '17px',
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  ice: {
    display: 'inline-block',
    '&:before': {
      display: 'inline-block',
      content: "''",
      background: `url(${iceModImg}) no-repeat left top`,
      width: '20px',
      height: '13px',
      marginLeft: 'auto',
      marginRight: 'auto'
    },
    '&:after': {
      display: 'inline-block',
      content: "''",
      background: `url(${iceSevImg}) no-repeat left top`,
      width: '20px',
      height: '13px',
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  }
}));


function LegendSigwx({contents: sigwx}) {
  const classes = useStyles();
  const timeInfo = useRecoilValue(weatherTimeWithID(WX_ID_SIGWX));
  const [dataSource, setDataSource] = useState(sigwx.getDataSource());

  const handleDataSourceChange = useCallback(event => {
    sigwx.setDataSource(event.target.value);
    setDataSource(event.target.value);
  }, [sigwx]);

  return (
    <div>
      <div className="legend-contents-time">
        {timeInfo.validTime}&nbsp;{timeInfo.baseTime}
      </div>
      <div>
        <RadioGroup row aria-label="position" name="rdo-diff-mode" value={dataSource}>
          <FormControlLabel value={SIGWX_WASHINGTON} control={<Radio color="primary" size="small"/>} label={<span className={classes.dataSourceLabel}>Washington</span>} onChange={handleDataSourceChange}/>
          <FormControlLabel value={SIGWX_LONDON} control={<Radio color="primary" size="small"/>} label={<span className={classes.dataSourceLabel}>London</span>} onChange={handleDataSourceChange}/>
        </RadioGroup>
      </div>
      <ul className={classes.box}>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={jetImg} alt="Jet" className={classes.icon+ ' ' + classes.iconJet}/></span><span className={classes.label}>Jet</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={cbImg} alt="CB" className={classes.icon + ' ' + classes.iconCB}/></span><span className={classes.label}>CB</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={tropicStormSevNImg} alt="Tropical cyclone" className={classes.icon + ' ' + classes.iconMini}/></span><span className={classes.label}>Tropical cyclone</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={tropoHighImg} alt="Tropopause High" className={classes.icon + ' ' + classes.iconMini}/></span><span className={classes.label}>Tropopause High</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={tropoHeightImg} alt="Tropopause Height" className={classes.icon + ' ' + classes.iconTropoHeight}/></span><span className={classes.label}>Tropopause Height</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><img src={tropoLowImg} alt="Tropopause Low" className={classes.icon + ' ' + classes.iconMini}/></span><span className={classes.label}>Tropopause Low</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><div className={classes.catLine + ' ' + classes.catMod}/></span><span className={classes.label}>CAT MOD</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><div className={classes.catLine + ' ' + classes.catModSev}/></span><span className={classes.label}>CAT MOD TO SEV</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><div className={classes.catLine + ' ' + classes.catSev}/></span><span className={classes.label}>CAT SEV</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><div className={classes.turb}/></span><span className={classes.label}>Turb(MOD, SEV)</span>
        </li>
        <li className={classes.item}>
          <span className={classes.iconWrap}><div className={classes.ice}/></span><span className={classes.label}>Icing(MOD, SEV)</span>
        </li>
      </ul>
    </div>
  )
}

export default LegendSigwx;